'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('react');
var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('../typography/ErrorText/ErrorText.js');
require('../typography/LargeDarkText/LargeDarkText.js');
require('../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../typography/MediumDarkText/MediumDarkText.js');
require('../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../typography/MediumText/MediumText.js');
require('../typography/MediumWhiteText/MediumWhiteText.js');
require('../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../typography/SmallDarkText/SmallDarkText.js');
require('../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../typography/SmallDisabledText/SmallDisabledText.js');
require('../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../typography/SmallLinkText/SmallLinkText.js');
require('../typography/SmallTitleText/SmallTitleText.js');
require('../typography/SmallWhiteText/SmallWhiteText.js');
require('../typography/TinyDarkText/TinyDarkText.js');
require('../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../typography/TinyLinkText/TinyLinkText.js');
require('../typography/TinyTitleText/TinyTitleText.js');
require('../typography/XXLargeDarkText/XXLargeDarkText.js');
require('../AlertBanner/AlertBanner.js');
require('../snackbars/AlertSnackBar/AlertSnackBar.js');
require('../snackbars/BottomCenterSnackbar/BottomCenterSnackbar.js');

var ErrorDetail = styled__default(SmallDarkText)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var ErrorPrefix = styled__default.p(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  white-space: pre-wrap;\n  margin: 0;\n  background-color: transparent;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n"], ["\n  white-space: pre-wrap;\n  margin: 0;\n  background-color: transparent;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n"])));
var errorTranslations = {
    'An unexpected error has occurred': 'unexpectedError',
    'Not Found': 'notFound',
    INVALID_TYPE: 'invalidType',
    ENUM_MISMATCH: 'enumMismatch',
    DUPLICATES: 'duplicates',
    INVALID_FORMAT: 'invalidFormat',
    '400': 'badRequest',
    PATTERN: 'pattern',
};
var getMessages = function (errors, fm, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
logFn) {
    if (logFn) {
        logFn(errors);
    }
    var errorMessages = [];
    if (errors instanceof Error) {
        errorMessages.push(errors.message);
    }
    else if (typeof errors === 'string') {
        var message = errors in errorTranslations
            ? fm({ id: "appWide.apiErrors." + errorTranslations[errors] })
            : errors;
        if (message)
            errorMessages.push(message);
    }
    else if (Array.isArray(errors)) {
        var stringMesssages = errors.map(function (error) {
            return typeof error === 'string' ? error : JSON.stringify(error);
        });
        errorMessages = errorMessages.concat(stringMesssages);
        // This is to handle the JSON API error object.
    }
    else if (errors.errors || errors.results) {
        if (errors.results && !errors.errors) {
            return getMessages(errors.results, fm);
        }
        var jsonApiErrors = errors.errors;
        var jsonMessages = jsonApiErrors.map(function (error) {
            var _a;
            return "" + fm({ id: "appWide.apiErrors." + errorTranslations[(_a = error.code) !== null && _a !== void 0 ? _a : error.status] }) + (error.detail ? ": " + error.detail : '');
        });
        errorMessages = errorMessages.concat(jsonMessages);
    }
    return errorMessages;
};
var templateObject_1, templateObject_2;

exports.getMessages = getMessages;
